// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3804f2b0","952":"faa3ca5c"}[chunkId] + ".chunk.js";
};